var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotumAlternative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 38,
    viewBox: "0 0 164 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.4151 8H89V38H102L116 8H110.5L98 35H93.4151V8Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 4.5V38H84V5L117.5 4.5L120 0H45.5L48 4.5H79.5Z",
    fill: "#656565"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0L0 38H5.5L19 8.5L29.5 30.5L40 8.5L53.5 38H59L41 0H38.5L29.5 19.5L20 0H18Z",
    fill: "#656565"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 12.5763L68 34.9492L64 38L50 8L57.5 12.5763Z",
    fill: "#656565"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68 34.9492L64 38H76.5L72 34.9492H68Z",
    fill: "#656565"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 38L72 34.9492V12.5763L76.5 8V38Z",
    fill: "#656565"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 8L72 12.5763H57.5L50 8H76.5Z",
    fill: "#656565"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123 0L105 38H110.5L124 8.5L134.5 30.5L145 8.5L158.5 38H164L146 0H143.5L134.5 19.5L125 0H123Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotumAlternative);
export default __webpack_public_path__ + "static/media/motum-alternative.882e65545ef845f2ecd9e30659c11399.svg";
export { ForwardRef as ReactComponent };